import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { ammControlloFormValidators } from '../../validators/amm-controllo-common.form-validators';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { normeSpaOrdinarioAssembleaRules } from './norme-spa-ordinario-assemblea.rules';
import { normeSpaOrdinarioTipoAmmRules } from './norme-spa-ordinario-tipo-amm.rules';
import { normeSpaOrdinarioOrganoControlloRules } from './norme-spa-ordinario-organo-controllo.rules';

export const NormeSpaOrdinarioRules: FormGroupRules = {
    ...normeSpaOrdinarioAssembleaRules,
    ...normeSpaOrdinarioTipoAmmRules,
    ...normeSpaOrdinarioOrganoControlloRules,
};

export const NormeSpaOrdinarioFormValidators = [...Object.values(NormeSpaOrdinarioRules), ...ammControlloFormValidators(CkNormeValuesEnum.normeSpaOrdinario)];
